module.exports = __webpack_public_path__ + "img/multi-window-statement.72bb9343.png";